import { Component } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ContentService } from '@markant-platform/shared/content/data-access';

@Component({
  selector: 'markant-platform-cms-background',
  templateUrl: './cms-background.component.html',
})
export class CmsBackgroundComponent {
  readonly backgroundCss$: Observable<{ [p: string]: unknown }>;

  constructor(private contentService: ContentService) {
    this.backgroundCss$ = this.contentService.getCatalogStageImage(true).pipe(
      map(backgroundImage => {
        return {
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: -1,
          width: '100vw',
          height: '100vh',
          backgroundImage: `linear-gradient(to top, var(--mel-gradient-1) 30%, transparent 100%), image-set("${backgroundImage.url}&w=1920" 1x, "${backgroundImage.url}&w=3840" 2x)`,
          backgroundSize: 'cover',
          backgroundRepeat: 'repeat-x, no-repeat',
          backgroundAttachment: 'fixed',
          backgroundPosition: 'bottom center, 0% 0%',
        };
      })
    );
  }
}
